import { Routes } from '@angular/router';

export const onboardingRoutes: Routes = [
  {
    path: '',
    redirectTo: '1',
    pathMatch: 'full',
  },
  {
    path: ':step',
    loadComponent: () =>
      import('./onboarding.page').then((m) => m.OnboardingPage),
  },
];
